/** Comic-style animal avatars (Noto Emoji artwork, Apache 2.0 — see
 * public/avatars/LICENSE.md). Everyone gets a deterministic animal until
 * they pick their own or upload a photo. */
export const ANIMAL_AVATARS = [
  'fox',
  'panda',
  'koala',
  'bear',
  'cat',
  'dog',
  'rabbit',
  'tiger',
  'lion',
  'frog',
  'owl',
  'penguin',
  'monkey',
  'pig',
  'hamster',
  'unicorn',
  'elephant',
  'giraffe',
  'zebra',
  'cow',
  'wolf',
  'dolphin',
  'shark',
  'octopus',
  'turtle',
  'duck',
  'flamingo',
  'chick',
  'hedgehog',
  'sloth',
  'llama',
  'trex',
  'bee',
  'butterfly',
  'polarbear',
] as const

export type AnimalAvatar = (typeof ANIMAL_AVATARS)[number]

export function animalAvatarUrl(animal: AnimalAvatar): string {
  return `/avatars/${animal}.svg`
}

export function isAnimalAvatarUrl(url: string): boolean {
  return ANIMAL_AVATARS.some((animal) => url === animalAvatarUrl(animal))
}

/** Stable hash of the user id so the same person always gets the same animal. */
export function defaultAvatarUrl(userId: string): string {
  let hash = 0
  for (let i = 0; i < userId.length; i += 1) hash = (hash * 31 + userId.charCodeAt(i)) >>> 0
  return animalAvatarUrl(ANIMAL_AVATARS[hash % ANIMAL_AVATARS.length])
}

export function avatarSrc(user: { id: string; avatarUrl?: string }): string {
  return user.avatarUrl || defaultAvatarUrl(user.id)
}
